import React from 'react'

const Qual12 = () => {
    return (
        <div>
              <div className='container'>
            <h1>Find whether an array is subset of another array</h1>
            <p>Given two arrays: arr1[0..m-1] and arr2[0..n-1]. Find whether arr2[] is a subset of arr1[] or not. Both the arrays are not in sorted order. It may be assumed that elements in both array are distinct.</p>
            <p><strong>Examples:</strong>&nbsp;</p>
            <blockquote className='containers'><p><strong>Input</strong>: arr1[] = &#123;11, 1, 13, 21, 3, 7&#125;, arr2[] = &#123;11, 3, 7, 1&#125;&nbsp;<br/>
            <strong>Output</strong>: arr2[] is a subset of arr1[]</p><p><strong>Input</strong>: arr1[] = &#123;1, 2, 3, 4, 5, 6&#125;, arr2[] = &#123;1, 2, 4&#125;&nbsp;<br/>
            <strong>Output</strong>: arr2[] is a subset of arr1[]</p><p><strong>Input</strong>: arr1[] = &#123;10, 5, 2, 23, 19&#125;, arr2[] = &#123;19, 5, 3&#125;&nbsp;<br/>
            <strong>Output</strong>: arr2[] is not a subset of arr1[]&nbsp;</p><br/>
            </blockquote>
            <p><strong>Solution (Use Set)</strong></p>
            <ul><li>Insert into the set for the first array; that’s how we will know the elements in the array.</li><li>Save the size of the array after inserting the first array element.</li><li>Insert into the same set for the second array.</li><li>Check if the size of the set is still the same or not, if it is then it’s true else false.</li></ul>

            <div class="tabs">
    <input type="radio" name="tab" id="tab1" />
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab4">C</label>

  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
    <div class="line number2 index1 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number5 index4 alt2"><code class="plain">&#123;</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// code</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">arr1[] = &#123; 11, 1, 13, 21, 3, 7 &#125;;</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">arr2[] = &#123; 11, 3, 7, 1 &#125;;</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">m = </code><code class="keyword bold">sizeof</code><code
            class="plain">(arr1) / </code><code class="keyword bold">sizeof</code><code class="plain">(arr1[0]);</code>
    </div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">n = </code><code class="keyword bold">sizeof</code><code
            class="plain">(arr2) / </code><code class="keyword bold">sizeof</code><code class="plain">(arr2[0]);</code>
    </div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">unordered_set&lt;</code><code class="color1 bold">int</code><code class="plain">&gt; s;</code>
    </div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i = 0; i &lt; m; i++) &#123;</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.insert(arr1[i]);</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">p = s.size();</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i = 0; i &lt; n; i++) &#123;</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.insert(arr2[i]);</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(s.size() == p) &#123;</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"arr2[] is subset of arr1[] "</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&lt;&lt; </code><code class="string">"\n"</code><code class="plain">;</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code> <code class="plain">&#123;</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"arr2[] is not subset of arr1[] "</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&lt;&lt; </code><code class="string">"\n"</code><code class="plain">;</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number28 index27 alt1"><code class="plain">&#125;</code></div>
</div>
       </div>
      <div id="tab-content-2" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="keyword">import</code> <code class="plain">java.io.*;</code>
    </div>
    <div class="line number2 index1 alt1"><code class="keyword">import</code> <code class="plain">java.util.*;</code>
    </div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="keyword">class</code> <code class="plain">NooB</code></div>
    <div class="line number5 index4 alt2"><code class="plain">&#123;</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main (String[] args)</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number8 index7 alt1">&nbsp;</div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">arr1[] = &#123; </code><code class="value">11</code><code
            class="plain">, </code><code class="value">1</code><code class="plain">, </code><code
            class="value">13</code><code class="plain">, </code><code class="value">21</code><code
            class="plain">, </code><code class="value">3</code><code class="plain">, </code><code class="value">7</code>
        <code class="plain">&#125;;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">arr2[] = &#123; </code><code class="value">11</code><code
            class="plain">, </code><code class="value">3</code><code class="plain">, </code><code
            class="value">7</code><code class="plain">, </code><code class="value">1</code> <code
            class="plain">&#125;;</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">m=arr1.length;</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">n=arr2.length;</code></div>
    <div class="line number13 index12 alt2">&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Set&lt;Integer&gt; s = </code><code class="keyword">new</code> <code
            class="plain">HashSet&lt;Integer&gt;();</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">i = </code><code class="value">0</code><code class="plain">; i &lt; m; i++)</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.add(arr1[i]);</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">p = s.size();</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">i = </code><code class="value">0</code><code class="plain">; i &lt; n; i++)</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.add(arr2[i]);</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number24 index23 alt1">&nbsp;</div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(s.size() == p)</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"arr2[] is subset of arr1[] "</code> <code
            class="plain">+ </code><code class="string">"\n"</code><code class="plain">);</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"arr2[] is not subset of arr1[] "</code> <code
            class="plain">+ </code><code class="string">"\n"</code> <code class="plain">);</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number34 index33 alt1"><code class="plain">&#125;</code></div>
    <div class="line number35 index34 alt2">&nbsp;</div>
    <div class="line number36 index35 alt1"><code
            class="comments">// This code is contributed by avanitrachhadiya2155</code></div>
</div>
        </div>
     <div id="tab-content-3" class="tab-content">
     <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Python3 code</code></div>
    <div class="line number2 index1 alt1"><code class="plain">arr1 </code><code class="keyword">=</code> <code
            class="plain">[ </code><code class="value">11</code><code class="plain">, </code><code
            class="value">1</code><code class="plain">, </code><code class="value">13</code><code
            class="plain">, </code><code class="value">21</code><code class="plain">, </code><code
            class="value">3</code><code class="plain">, </code><code class="value">7</code> <code class="plain">]</code>
    </div>
    <div class="line number3 index2 alt2"><code class="plain">arr2 </code><code class="keyword">=</code> <code
            class="plain">[ </code><code class="value">11</code><code class="plain">, </code><code
            class="value">3</code><code class="plain">, </code><code class="value">7</code><code
            class="plain">, </code><code class="value">1</code> <code class="plain">]</code></div>
    <div class="line number4 index3 alt1"><code class="plain">m </code><code class="keyword">=</code> <code
            class="functions">len</code><code class="plain">(arr1)</code></div>
    <div class="line number5 index4 alt2"><code class="plain">n </code><code class="keyword">=</code> <code
            class="functions">len</code><code class="plain">(arr2)</code></div>
    <div class="line number6 index5 alt1"><code class="plain">s </code><code class="keyword">=</code> <code
            class="functions">set</code><code class="plain">()</code></div>
    <div class="line number7 index6 alt2"><code class="keyword">for</code> <code class="plain">i </code><code
            class="keyword">in</code> <code class="functions">range</code><code class="plain">(m) :</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.add(arr1[i])</code></div>
    <div class="line number9 index8 alt2">&nbsp;</div>
    <div class="line number10 index9 alt1"><code class="plain">p </code><code class="keyword">=</code> <code
            class="functions">len</code><code class="plain">(s)</code></div>
    <div class="line number11 index10 alt2"><code class="keyword">for</code> <code class="plain">i </code><code
            class="keyword">in</code> <code class="functions">range</code><code class="plain">(n) :</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s.add(arr2[i])</code></div>
    <div class="line number13 index12 alt2">&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="keyword">if</code> <code class="plain">(</code><code
            class="functions">len</code><code class="plain">(s) </code><code class="keyword">=</code><code
            class="keyword">=</code> <code class="plain">p) :</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(</code><code
            class="string">"arr2[] is subset of arr1[] "</code><code class="plain">)</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code class="keyword">else</code> <code class="plain">:</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">(</code><code
            class="string">"arr2[] is not subset of arr1[] "</code><code class="plain">)</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># This code is contributed by divyeshrabadiya07.</code></div>
</div>
    </div>
  
     </div>
  </div>
  <br /> <br /> <br /> <br /> <br />
        </div>
        </div>
    )
}

export default Qual12
